import { printDocument } from '../../lib/print-document.js';
import { marked } from '../../vendor/marked.js';

/**
 * The lines printed under a platform document's title: its version and, once
 * accepted, when.
 * @param {{ version: number, accepted?: boolean, accepted_at?: string }} agreement
 * @returns {string[]}
 */
export function agreementDetails(agreement) {
    const details = [`Version ${agreement.version}`];
    if (agreement.accepted && agreement.accepted_at) {
        details.push(`Accepted ${new Date(agreement.accepted_at).toUTCString()}`);
    }
    return details;
}

/**
 * Prints a platform document (terms, privacy notice, notice designation).
 * @param {{ title: string, version: number, body: string, accepted?: boolean, accepted_at?: string }} agreement
 */
export function printAgreement(agreement) {
    printDocument({
        title: agreement.title,
        details: agreementDetails(agreement),
        bodyHTML: marked.parse(agreement.body || ''),
    });
}
